export const clientId = '419786111606-a2f6h02fkaukbcjjlf8uivvmqp5i94br.apps.googleusercontent.com';
